export const environment = {
    apiRoot: 'https://adp.n-denton.com/adp_api',
    jwtToken: 'JWT_TOKEN',
};

